<!-- eslint-disable quotes -->
<!-- eslint-disable quotes -->
<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      :fullscreen="isMobileBreakpoint"
      persistent
      width="800px"
    >
      <v-card>
        <v-toolbar
          elevation="0"
          color="background"
          class="modalHeader mt-2"
          :class="{ borderBottom: !editingMode }"
        >
          <v-toolbar-title class="body-bold-medium ml-1">{{
            $t('message.ai.abstract.editEbook')
          }}</v-toolbar-title>

          <v-spacer></v-spacer>
          <!-- <BaseBtn
            type="secondary"
            class="elevation-0 mr-4 px-4"
            :disabled="checkIfHasChanged"
            @click="handleDiscardChanges"
          >
            {{ $t('message.pages.video.discardChanges') }}
          </BaseBtn> -->
          <base-btn
            v-if="!editingMode && !isMobileBreakpoint"
            :loading="loadings.updatingEbook"
            type="tertiary"
            @click="editEbook"
          >
            <v-icon size="20" class="mr-2">panda-edit</v-icon>
            {{ $t('message.ai.abstract.edit') }}
          </base-btn>
          <base-btn
            v-if="!editingMode && !isMobileBreakpoint"
            class="ml-3"
            :loading="loadings.updatingEbook"
            type="primary"
            @click="downloadEbook"
          >
            {{ $t('message.ai.abstract.downloadEbook') }}
            <v-icon size="20" class="ml-2">panda-download</v-icon>
          </base-btn>
          <base-btn
            v-if="editingMode && !isMobileBreakpoint"
            class="mr-2"
            :loading="loadings.updatingEbook"
            type="primary"
            @click="updateEbook"
          >
            {{ $t('message.pages.video.publish') }}
          </base-btn>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text
          justify="center"
          class="quillScroll"
          style="height: 600px; overflow-y: auto; width: 100%"
        >
          <quill-editor
            v-model="content"
            ref="myQuillEditor"
            :options="editorOptions"
          >
          </quill-editor>
          <div v-if="isMobileBreakpoint" class="mobileActionBtns pa-4">
            <base-btn
              v-if="!editingMode"
              :loading="loadings.updatingEbook"
              type="neutral"
              @click="downloadEbook"
            >
              {{ $t('message.ai.abstract.downloadEbook') }}
            </base-btn>
            <base-btn
              v-if="!editingMode"
              class="ml-5 px-10"
              :loading="loadings.updatingEbook"
              type="primary"
              @click="editEbook"
            >
              {{ $t('message.ai.abstract.edit') }}
            </base-btn>
            <base-btn
              v-if="editingMode"
              class="mr-2 px-10"
              :loading="loadings.updatingEbook"
              type="tertiary"
              @click="handleClose"
            >
              {{ $t('message.cancel') }}
            </base-btn>
            <base-btn
              v-if="editingMode"
              class="mr-2 px-10"
              :loading="loadings.updatingEbook"
              type="primary"
              @click="updateEbook"
            >
              {{ $t('message.pages.video.publish') }}
            </base-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <unsaved-changes-modal />
  </v-row>
</template>

<script>
import UnsavedChangesModal from '@/components/UnsavedChangesModal.vue'
import aiworkflowApi from '@/services/aiworkflowApi'
import _ from 'lodash'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import BaseBtn from '@/components/BaseBtn.vue'
import Quill from 'quill'
import { mapState, mapMutations } from 'vuex'
import i18n from '@/translations/lang'

const Parchment = Quill.import('parchment')
const BackgroundClass = new Parchment.Attributor.Class('background', 'ql-bg', {
  scope: Parchment.Scope.INLINE,
})
Quill.register(BackgroundClass, true)

const icons = Quill.import('ui/icons')

icons[
  'bold'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <path  clip-rule="evenodd" d="M3.3335 3.33329C3.3335 2.41282 4.07969 1.66663 5.00016 1.66663H11.6668C12.9929 1.66663 14.2647 2.19341 15.2024 3.13109C16.14 4.06877 16.6668 5.34054 16.6668 6.66663C16.6668 7.99271 16.14 9.26448 15.2024 10.2022C14.2647 11.1398 12.9929 11.6666 11.6668 11.6666C10.7464 11.6666 10.0002 10.9204 10.0002 9.99996C10.0002 9.07949 10.7464 8.33329 11.6668 8.33329C12.1089 8.33329 12.5328 8.1577 12.8453 7.84514C13.1579 7.53258 13.3335 7.10865 13.3335 6.66663C13.3335 6.2246 13.1579 5.80068 12.8453 5.48811C12.5328 5.17555 12.1089 4.99996 11.6668 4.99996H6.66683V9.99996C6.66683 10.9204 5.92064 11.6666 5.00016 11.6666C4.07969 11.6666 3.3335 10.9204 3.3335 9.99996V3.33329Z" />
  <path  clip-rule="evenodd" d="M3.3335 9.99996C3.3335 9.07949 4.07969 8.33329 5.00016 8.33329H12.5002C13.8262 8.33329 15.098 8.86008 16.0357 9.79776C16.9734 10.7354 17.5002 12.0072 17.5002 13.3333C17.5002 14.6594 16.9734 15.9311 16.0357 16.8688C15.098 17.8065 13.8262 18.3333 12.5002 18.3333H5.00016C4.07969 18.3333 3.3335 17.5871 3.3335 16.6666V9.99996ZM6.66683 11.6666V15H12.5002C12.9422 15 13.3661 14.8244 13.6787 14.5118C13.9912 14.1992 14.1668 13.7753 14.1668 13.3333C14.1668 12.8913 13.9912 12.4673 13.6787 12.1548C13.3661 11.8422 12.9422 11.6666 12.5002 11.6666H6.66683Z" />
</svg>`
icons[
  'italic'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" >
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50016 3.33332C7.50016 2.87308 7.87326 2.49998 8.3335 2.49998H15.8335C16.2937 2.49998 16.6668 2.87308 16.6668 3.33332C16.6668 3.79355 16.2937 4.16665 15.8335 4.16665H8.3335C7.87326 4.16665 7.50016 3.79355 7.50016 3.33332Z" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3335 16.6666C3.3335 16.2064 3.70659 15.8333 4.16683 15.8333H11.6668C12.1271 15.8333 12.5002 16.2064 12.5002 16.6666C12.5002 17.1269 12.1271 17.5 11.6668 17.5H4.16683C3.70659 17.5 3.3335 17.1269 3.3335 16.6666Z" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7928 2.55304C13.2237 2.71464 13.442 3.19498 13.2804 3.62592L8.28044 16.9593C8.11884 17.3902 7.63849 17.6085 7.20756 17.4469C6.77663 17.2853 6.55829 16.805 6.71989 16.374L11.7199 3.04071C11.8815 2.60978 12.3618 2.39144 12.7928 2.55304Z" />
</svg>`
icons[
  'underline'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5 2.5C5.46024 2.5 5.83333 2.8731 5.83333 3.33333V8.33333C5.83333 9.4384 6.27232 10.4982 7.05372 11.2796C7.83512 12.061 8.89493 12.5 10 12.5C11.1051 12.5 12.1649 12.061 12.9463 11.2796C13.7277 10.4982 14.1667 9.4384 14.1667 8.33333V3.33333C14.1667 2.8731 14.5398 2.5 15 2.5C15.4602 2.5 15.8333 2.8731 15.8333 3.33333V8.33333C15.8333 9.88043 15.2188 11.3642 14.1248 12.4581C13.0308 13.5521 11.5471 14.1667 10 14.1667C8.4529 14.1667 6.96917 13.5521 5.87521 12.4581C4.78125 11.3642 4.16667 9.88043 4.16667 8.33333V3.33333C4.16667 2.8731 4.53976 2.5 5 2.5Z" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 16.6667C2.5 16.2064 2.8731 15.8333 3.33333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667Z" />
</svg>`
icons['list']['ordered'] = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.50018 4.99996C2.50018 4.53972 2.87328 4.16663 3.33352 4.16663H4.16685C4.62709 4.16663 5.00018 4.53972 5.00018 4.99996V7.49996C5.46042 7.49996 5.83352 7.87306 5.83352 8.33329C5.83352 8.79353 5.46042 9.16663 5.00018 9.16663H3.33352C2.87328 9.16663 2.50018 8.79353 2.50018 8.33329C2.50018 7.87306 2.87328 7.49996 3.33352 7.49996V5.83329C2.87328 5.83329 2.50018 5.4602 2.50018 4.99996ZM7.50018 4.99996C7.50018 4.53972 7.87328 4.16663 8.33352 4.16663H17.5002C17.9604 4.16663 18.3335 4.53972 18.3335 4.99996C18.3335 5.4602 17.9604 5.83329 17.5002 5.83329H8.33352C7.87328 5.83329 7.50018 5.4602 7.50018 4.99996ZM7.50018 9.99996C7.50018 9.53972 7.87328 9.16663 8.33352 9.16663H17.5002C17.9604 9.16663 18.3335 9.53972 18.3335 9.99996C18.3335 10.4602 17.9604 10.8333 17.5002 10.8333H8.33352C7.87328 10.8333 7.50018 10.4602 7.50018 9.99996ZM4.85203 10.8692C5.45473 11.1705 5.83352 11.7766 5.83352 12.5C5.83352 12.9802 5.59859 13.3688 5.40643 13.625C5.26183 13.8178 5.08787 14.0036 4.92778 14.1666H5.00018C5.46042 14.1666 5.83352 14.5397 5.83352 15C5.83352 15.4602 5.46042 15.8333 5.00018 15.8333H3.33352C2.87328 15.8333 2.50018 15.4602 2.50018 15C2.50018 14.5197 2.73511 14.1312 2.92727 13.875C3.11956 13.6186 3.36376 13.3745 3.55825 13.18C3.56475 13.1735 3.5712 13.1671 3.57759 13.1607C3.79682 12.9415 3.95933 12.7767 4.0731 12.625C4.13593 12.5412 4.15871 12.4935 4.16613 12.4761C4.163 12.4259 4.15045 12.4016 4.14512 12.3929C4.13864 12.3822 4.12839 12.3708 4.10667 12.3599C4.06456 12.3388 3.9265 12.3018 3.70619 12.412C3.29455 12.6178 2.79398 12.451 2.58816 12.0393C2.38234 11.6277 2.54919 11.1271 2.96084 10.9213C3.57386 10.6148 4.26914 10.5777 4.85203 10.8692ZM7.50018 15C7.50018 14.5397 7.87328 14.1666 8.33352 14.1666H17.5002C17.9604 14.1666 18.3335 14.5397 18.3335 15C18.3335 15.4602 17.9604 15.8333 17.5002 15.8333H8.33352C7.87328 15.8333 7.50018 15.4602 7.50018 15Z" />
</svg>`

icons['list']['bullet'] = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M2.5 10H2.50833" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.5 15H2.50833" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.5 5H2.50833" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.6665 10H17.4998" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.6665 15H17.4998" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.6665 5H17.4998" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
icons[
  'ordered'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9107 2.74408C12.2362 2.41864 12.7638 2.41864 13.0893 2.74408L17.2559 6.91074C17.5814 7.23618 17.5814 7.76382 17.2559 8.08926L13.0893 12.2559C12.7638 12.5814 12.2362 12.5814 11.9107 12.2559C11.5853 11.9305 11.5853 11.4028 11.9107 11.0774L14.6548 8.33333H7.91667C6.9221 8.33333 5.96828 8.72842 5.26502 9.43168C4.56175 10.1349 4.16667 11.0888 4.16667 12.0833C4.16667 12.5758 4.26366 13.0634 4.45212 13.5184C4.64057 13.9734 4.9168 14.3868 5.26502 14.735C5.96828 15.4382 6.9221 15.8333 7.91667 15.8333H10.8333C11.2936 15.8333 11.6667 16.2064 11.6667 16.6667C11.6667 17.1269 11.2936 17.5 10.8333 17.5H7.91667C6.48008 17.5 5.10233 16.9293 4.0865 15.9135C3.58352 15.4105 3.18453 14.8134 2.91232 14.1562C2.64011 13.499 2.5 12.7947 2.5 12.0833C2.5 10.6467 3.07068 9.26899 4.0865 8.25317C5.10233 7.23735 6.48008 6.66667 7.91667 6.66667H14.6548L11.9107 3.92259C11.5853 3.59715 11.5853 3.06951 11.9107 2.74408Z" fill="#ABADBA"/>
</svg>`
icons[
  'link'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_5671_838)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6456 2.29223C11.5886 1.38144 12.8516 0.877469 14.1626 0.888861C15.4736 0.900253 16.7276 1.4261 17.6547 2.35314C18.5817 3.28018 19.1076 4.53424 19.119 5.84522C19.1304 7.15621 18.6264 8.41922 17.7156 9.36223L17.7054 9.37256L15.2055 11.8725C14.6987 12.3795 14.0886 12.7716 13.4169 13.0222C12.7451 13.2728 12.0273 13.376 11.3122 13.3248C10.5971 13.2736 9.90129 13.0692 9.27209 12.7254C8.6429 12.3816 8.095 11.9066 7.66554 11.3325C7.38987 10.9639 7.46516 10.4417 7.8337 10.166C8.20224 9.89033 8.72448 9.96561 9.00015 10.3342C9.28645 10.7169 9.65172 11.0336 10.0712 11.2628C10.4906 11.492 10.9545 11.6282 11.4313 11.6624C11.908 11.6965 12.3865 11.6277 12.8344 11.4607C13.2822 11.2936 13.6889 11.0322 14.0268 10.6942L16.5215 8.19945C17.1257 7.57131 17.4599 6.73142 17.4524 5.85971C17.4448 4.98572 17.0942 4.14968 16.4762 3.53165C15.8581 2.91362 15.0221 2.56306 14.1481 2.55546C13.276 2.54789 12.4358 2.88239 11.8075 3.48709L10.3787 4.90761C10.0523 5.2321 9.5247 5.23056 9.20021 4.90417C8.87572 4.57779 8.87726 4.05015 9.20365 3.72567L10.637 2.30067L10.6456 2.29223Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.58214 6.97771C7.2539 6.72712 7.97169 6.62394 8.68684 6.67516C9.40198 6.72637 10.0977 6.93079 10.7269 7.27455C11.3561 7.61831 11.904 8.09336 12.3335 8.66749C12.6092 9.03603 12.5339 9.55827 12.1653 9.83394C11.7968 10.1096 11.2745 10.0343 10.9989 9.66579C10.7126 9.28303 10.3473 8.96633 9.92784 8.73716C9.50838 8.50799 9.04454 8.37171 8.56778 8.33756C8.09102 8.30342 7.61249 8.37221 7.16465 8.53927C6.71681 8.70632 6.31013 8.96774 5.97221 9.30579L3.47751 11.8005C2.87331 12.4286 2.5391 13.2685 2.54668 14.1402C2.55427 15.0142 2.90483 15.8503 3.52286 16.4683C4.14089 17.0863 4.97693 17.4369 5.85092 17.4445C6.72262 17.4521 7.56251 17.1178 8.19065 16.5137L9.61026 15.094C9.9357 14.7686 10.4633 14.7686 10.7888 15.094C11.1142 15.4195 11.1142 15.9471 10.7888 16.2726L9.36377 17.6976L9.35344 17.7077C8.41043 18.6185 7.14742 19.1225 5.83644 19.1111C4.52545 19.0997 3.27139 18.5738 2.34435 17.6468C1.41731 16.7198 0.891464 15.4657 0.880072 14.1547C0.86868 12.8437 1.37265 11.5807 2.28344 10.6377L2.29359 10.6274L4.79349 8.12749C4.79352 8.12745 4.79345 8.12752 4.79349 8.12749C5.30035 7.62047 5.91043 7.22828 6.58214 6.97771Z" />
  </g>
  <defs>
    <clipPath id="clip0_5671_838">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>`
icons[
  'undo'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.08926 2.74408C8.41469 3.06951 8.41469 3.59715 8.08926 3.92259L5.34518 6.66667H12.0833C12.7947 6.66667 13.499 6.80677 14.1562 7.07899C14.8134 7.3512 15.4105 7.75019 15.9135 8.25317C16.4165 8.75616 16.8155 9.35328 17.0877 10.0105C17.3599 10.6676 17.5 11.372 17.5 12.0833C17.5 12.7947 17.3599 13.499 17.0877 14.1562C16.8155 14.8134 16.4165 15.4105 15.9135 15.9135C15.4105 16.4165 14.8134 16.8155 14.1562 17.0877C13.499 17.3599 12.7947 17.5 12.0833 17.5H9.16667C8.70643 17.5 8.33333 17.1269 8.33333 16.6667C8.33333 16.2064 8.70643 15.8333 9.16667 15.8333H12.0833C12.5758 15.8333 13.0634 15.7363 13.5184 15.5479C13.9734 15.3594 14.3868 15.0832 14.735 14.735C15.0832 14.3868 15.3594 13.9734 15.5479 13.5184C15.7363 13.0634 15.8333 12.5758 15.8333 12.0833C15.8333 11.5909 15.7363 11.1032 15.5479 10.6483C15.3594 10.1933 15.0832 9.7799 14.735 9.43168C14.3868 9.08346 13.9734 8.80724 13.5184 8.61879C13.0634 8.43033 12.5758 8.33333 12.0833 8.33333H5.34518L8.08926 11.0774C8.41469 11.4028 8.41469 11.9305 8.08926 12.2559C7.76382 12.5814 7.23618 12.5814 6.91074 12.2559L2.74408 8.08926C2.41864 7.76382 2.41864 7.23618 2.74408 6.91074L6.91074 2.74408C7.23618 2.41864 7.76382 2.41864 8.08926 2.74408Z" />
</svg>`
icons[
  'redo'
] = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9107 2.74408C12.2362 2.41864 12.7638 2.41864 13.0893 2.74408L17.2559 6.91074C17.5814 7.23618 17.5814 7.76382 17.2559 8.08926L13.0893 12.2559C12.7638 12.5814 12.2362 12.5814 11.9107 12.2559C11.5853 11.9305 11.5853 11.4028 11.9107 11.0774L14.6548 8.33333H7.91667C6.9221 8.33333 5.96828 8.72842 5.26502 9.43168C4.56175 10.1349 4.16667 11.0888 4.16667 12.0833C4.16667 12.5758 4.26366 13.0634 4.45212 13.5184C4.64057 13.9734 4.9168 14.3868 5.26502 14.735C5.96828 15.4382 6.9221 15.8333 7.91667 15.8333H10.8333C11.2936 15.8333 11.6667 16.2064 11.6667 16.6667C11.6667 17.1269 11.2936 17.5 10.8333 17.5H7.91667C6.48008 17.5 5.10233 16.9293 4.0865 15.9135C3.58352 15.4105 3.18453 14.8134 2.91232 14.1562C2.64011 13.499 2.5 12.7947 2.5 12.0833C2.5 10.6467 3.07068 9.26899 4.0865 8.25317C5.10233 7.23735 6.48008 6.66667 7.91667 6.66667H14.6548L11.9107 3.92259C11.5853 3.59715 11.5853 3.06951 11.9107 2.74408Z"/>
</svg>`

export default {
  name: 'VideoPlayerEbookModal',
  components: { quillEditor, BaseBtn, UnsavedChangesModal },
  data: () => ({
    open: false,
    editingMode: false,
    isEditing: false,
    content: '',
    initialContentVal: '',
    loadings: {
      updatingEbook: false,
    },
    editorOptions: {
      debug: 'info',
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline'],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['undo', 'redo'],
          ],
          handlers: {
            undo: function () {
              this.quill.history.undo()
            },
            redo: function () {
              this.quill.history.redo()
            },
          },
        },
      },
      scrollingContainer: 'quillScroll',
    },
  }),

  mounted() {
    this.$root.$on('openVideoEbookModal', (data) => {
      this.open = true
      this.setAbstract(data.ebook)
      this.$nextTick(() => {
        if (data.editMode) {
          this.editEbook()
        }
      })
    })

    this.$root.$on('handleGoForwardEbookModalChanges', () => {
      const qlSnow = document.querySelector('.ql-snow')
      if (qlSnow) {
        qlSnow.style.display = 'none'
      }
      this.editingMode = false
      this.open = null
    })

    document.addEventListener('click', (event) => {
      const target = event.target.closest('.ql-undo')
      if (target) {
        this.updateHistoryState()
      }
    })

    // Adiciona listener para botão redo
    document.addEventListener('click', (event) => {
      const target = event.target.closest('.ql-redo')
      if (target) {
        this.updateHistoryState()
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.ctrlKey && !event.shiftKey && event.key === 'z') {
        event.preventDefault()
        this.handleUndo()
      } else if (event.ctrlKey && event.shiftKey && event.key === 'z') {
        event.preventDefault()
        this.handleRedo()
      }
    })
  },
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    checkIfHasChanged() {
      return _.isEqual(this.content, this.initialContentVal)
    },
  },
  watch: {},
  beforeDestroy() {
    document.removeEventListener('click', this.handleUndoClick)
    document.removeEventListener('click', this.handleRedoClick)
    document.removeEventListener('keydown', this.handleUndoRedoKeydown)
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    setAbstract(abstract) {
      let val = _.cloneDeep(abstract)
      this.content = this.convertToQuillHTML(val)

      this.$nextTick(() => {
        this.initialContentVal = _.cloneDeep(this.content)

        const quill = this.$refs.myQuillEditor?.quill
        if (quill) {
          quill.history.clear()
          quill.history.stack.undo = []
          quill.history.stack.redo = []
          quill.enable(this.editingMode)
        }
      })
    },
    teste() {
      this.$root.$emit(
        'unsavedChangesModal',
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true
      )
    },
    addTooltipsToToolbar() {
      const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform)

      const tooltips = {
        '.ql-bold': `${this.$t('message.ai.abstract.bold')} (${
          isMac ? 'Cmd + B' : 'Ctrl + B'
        })`,
        '.ql-italic': `${this.$t('message.ai.abstract.italic')} (${
          isMac ? 'Cmd + I' : 'Ctrl + I'
        })`,
        '.ql-underline': `${this.$t('message.ai.abstract.underline')} (${
          isMac ? 'Cmd + U' : 'Ctrl + U'
        })`,
        '.ql-list[value="ordered"]': this.$t('message.ai.abstract.numericList'),
        '.ql-list[value="bullet"]': this.$t('message.ai.abstract.bulletList'),
        '.ql-link': `${this.$t('message.ai.abstract.link')} (${
          isMac ? 'Cmd + K' : 'Ctrl + K'
        })`,
        '.ql-undo': `${this.$t('message.ai.abstract.undo')} (${
          isMac ? 'Cmd + Z' : 'Ctrl + Z'
        })`,
        '.ql-redo': `${this.$t('message.ai.abstract.redo')} (${
          isMac ? 'Cmd + Shift + Z' : 'Ctrl + Shift + Z'
        })`,
      }

      // Adiciona os tooltips aos botões da toolbar
      Object.entries(tooltips).forEach(([selector, tooltip]) => {
        const button = document.querySelector(`.ql-toolbar ${selector}`)
        if (button) {
          button.setAttribute('data-tooltip', tooltip)
        }
      })
    },
    convertToQuillHTML(markdownText) {
      const lines = markdownText.split(/\r?\n/)
      let quillHTML = ''
      let inList = false

      lines.forEach((line) => {
        if (/^###### /.test(line)) {
          quillHTML += `<h6>${line.replace(/^###### /, '')}</h6>`
        } else if (/^##### /.test(line)) {
          quillHTML += `<h5>${line.replace(/^##### /, '')}</h5>`
        } else if (/^#### /.test(line)) {
          quillHTML += `<h4>${line.replace(/^#### /, '')}</h4>`
        } else if (/^### /.test(line)) {
          quillHTML += `<h3>${line.replace(/^### /, '')}</h3>`
        } else if (/^## /.test(line)) {
          quillHTML += `<h2>${line.replace(/^## /, '')}</h2>`
        } else if (/^# /.test(line)) {
          quillHTML += `<h1>${line.replace(/^# /, '')}</h1>`
        } else if (/^- /.test(line)) {
          if (!inList) {
            quillHTML += '<ul>'
            inList = true
          }
          quillHTML += `<li>${line.replace(/^- /, '')}</li>`
        } else if (line.trim() === '') {
          if (inList) {
            quillHTML += '</ul>'
            inList = false
          }
          quillHTML += '<p><br></p>' // Mantém quebras de linha
        } else {
          if (inList) {
            quillHTML += '</ul>'
            inList = false
          }
          quillHTML += `<p>${line}</p>`
        }
      })

      if (inList) {
        quillHTML += '</ul>'
      }

      return quillHTML.trim()
    },

    handleInlineStyles(line) {
      line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      line = line.replace(/__(.*?)__/g, '<u>$1</u>')
      line = line.replace(/\*(.*?)\*/g, '<em>$1</em>')
      // Add support for other inline styles here if needed
      return line
    },
    updateHistoryState() {
      if (this.$refs.myQuillEditor) {
        const quill = this.$refs.myQuillEditor.quill
        this.canUndo = quill.history.stack.undo.length > 1
        this.canRedo = quill.history.stack.redo.length > 0
        console.log('canUndo', this.canUndo)
        console.log('canRedo', this.canRedo)
        const qlUndo = document.querySelector('.ql-undo')
        const qlRedo = document.querySelector('.ql-redo')
        if (this.canUndo) {
          qlUndo.classList.remove('ql-disabled')
        } else {
          qlUndo.classList.add('ql-disabled')
        }
        if (this.canRedo) {
          qlRedo.classList.remove('ql-disabled')
        } else {
          qlRedo.classList.add('ql-disabled')
        }
      }
    },
    handleUndo() {
      if (this.$refs.myQuillEditor) {
        this.$refs.myQuillEditor.quill.history.undo()
        this.updateHistoryState()
      }
    },
    handleRedo() {
      if (this.$refs.myQuillEditor) {
        this.$refs.myQuillEditor.quill.history.redo()
        this.updateHistoryState()
      }
    },
    editEbook() {
      this.editingMode = true
      const qlSnow = document.querySelector('.ql-snow')
      qlSnow.style.display = 'flex'
      this.addTooltipsToToolbar()
      this.updateHistoryState()
      const quill = this.$refs.myQuillEditor?.quill
      if (quill) {
        quill.enable(true)
        quill.on('text-change', () => {
          console.log('text-change')
          this.updateHistoryState()
        })
      }
    },
    downloadEbook() {
      this.$root.$emit('handleDownloadEbook')
    },
    convertToMarkdown(quillHTML) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(quillHTML, 'text/html')
      let markdown = ''

      function convertElementToMarkdown(element) {
        switch (element.tagName.toLowerCase()) {
          case 'h1':
            return `# ${element.textContent}\n`
          case 'h2':
            return `## ${element.textContent}\n`
          case 'h3':
            return `### ${element.textContent}\n`
          case 'h4':
            return `#### ${element.textContent}\n`
          case 'h5':
            return `##### ${element.textContent}\n`
          case 'h6':
            return `###### ${element.textContent}\n`
          case 'p':
            // Mantém parágrafos vazios
            return element.innerHTML === '<br>'
              ? '\n'
              : `${element.textContent}\n`
          case 'ul':
            return (
              Array.from(element.children)
                .map((li) => `- ${li.textContent}`)
                .join('\n') + '\n'
            )
          case 'ol':
            return (
              Array.from(element.children)
                .map((li, index) => `${index + 1}. ${li.textContent}`)
                .join('\n') + '\n'
            )
          case 'br':
            return '\n' // Mantém quebras de linha
          default:
            return element.textContent
        }
      }

      Array.from(doc.body.children).forEach((element) => {
        markdown += convertElementToMarkdown(element)
      })

      // Mantém quebras de linha conforme inserido
      return markdown.replace(/\n{3,}/g, '\n\n').trim()
    },
    handleDiscardChanges() {
      this.content = _.cloneDeep(this.initialContentVal)
      this.initialContentVal = _.cloneDeep(this.content)
    },
    async updateEbook() {
      this.loadings.updatingEbook = true
      const videoId = this.$route.params.id
      let newTextValue = this.convertToMarkdown(this.content)

      const aiData = {
        video_id: videoId,
        abstract: newTextValue,
      }

      try {
        let res = await aiworkflowApi.updateAiWorkFlowData(aiData)
        this.setAbstract(res.data.abstract)
        this.initialContentVal = _.cloneDeep(this.content)
        this.$root.$emit('updateEbookData', res.data.abstract)
        this.loadings.updatingEbook = false
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.ai.abstract.ebookStatus'),
          type: 'success',
        })
        this.handleClose()
      } catch (e) {
        this.loadings.updatingEbook = false
        console.error('Erro ao salvar:', e)
      }
    },
    handleClose() {
      if (!_.isEqual(this.content, this.initialContentVal)) {
        this.$root.$emit(
          'unsavedChangesModal',
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          true
        )
        return
      }
      const qlSnow = document.querySelector('.ql-snow')
      if (qlSnow) {
        qlSnow.style.display = 'none'
      }
      const quill = this.$refs.myQuillEditor?.quill
      if (quill) {
        quill.enable(false) // Desativa edição ao fechar
      }
      this.editingMode = false
      this.open = false
    },
  },
}
</script>

<style scoped lang="scss">
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.mobileActionBtns {
  border-top: 1px solid varFigma(neutral-95-lightest);
  position: sticky;
  bottom: 0;
  background: varFigma(neutral-100-white);
}

.ql-formats {
  display: flex !important;
  align-items: center !important;
}

.modalHeader {
  position: sticky;
  top: 0;
  z-index: 15;
  background-color: var(--neutral-background, #fff);
  height: 45px !important;
}

.borderBottom {
  border-bottom: 1px solid varFigma(neutral-95-lightest) !important;
  height: 72px !important;
}

::v-deep .ql-toolbar.ql-snow {
  display: none;
}

::v-deep .ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  width: 32px !important;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

::v-deep .ql-toolbar.ql-snow .ql-formats {
  margin-right: 0;
}

// ::v-deep .ql-picker-label svg {
//   display: none;
// }

::v-deep .ql-toolbar .ql-formats button {
  svg {
    fill: #636578;
    transition: fill 0.2s ease !important;
  }

  &:hover {
    border-radius: var(--spacing-02, 4px);
    background: varFigma(neutral-95-lightest);
    .svg {
      fill: #b9bac0 !important;
    }
  }

  &.ql-active {
    border-radius: var(--spacing-02, 4px);
    background: varFigma(neutral-90);
    .svg {
      fill: #b9bac0 !important;
    }
  }
}

.scroll-container {
  max-height: 400px;
  overflow-y: auto;
}

.ql-container {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ql-toolbar.ql-snow {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
  border: none;
  border-bottom: 1px solid varFigma(neutral-95-lightest) !important;
  padding: 20px 20px;
}

::v-deep .ql-container.ql-snow {
  border: none !important;
  padding: 30px !important;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0 !important;
}
</style>

<style lang="scss">
.ql-toolbar .ql-formats .ql-undo {
  margin-left: 12px;
}
.ql-formats {
  display: flex !important;
  align-items: center !important;
}

.ql-snow.ql-toolbar .ql-picker-label.ql-active {
  color: varFigma(neutral-20-dark);
}

.ql-editor {
  color: varFigma(neutral-20-dark);
}

.ql-disabled {
  pointer-events: none !important;
}

.ql-toolbar .ql-formats button {
  svg {
    fill: #636578 !important;
    transition: fill 0.2s ease !important;
  }

  &:hover svg {
    fill: #b9bac0 !important;
  }

  &.ql-active svg {
    fill: #b9bac0 !important;
  }

  &.ql-disabled svg {
    fill: varFigma(neutral-70) !important;
  }
}

.ql-snow .ql-picker.ql-header {
  border: 1px solid varFigma(neutral-95-lightest);
  border-radius: 4px;
  margin: 0 14px 0 10px;
  font-size: 12px;
  font-weight: 400;
  width: 176px;
}

.ql-toolbar .ql-formats button.ql-list[value='bullet'] svg path {
  stroke: #636578;
  transition: stroke 0.2s ease;
}

.ql-toolbar .ql-formats button.ql-list[value='bullet']:hover svg path {
  stroke: #b9bac0;
}

.ql-toolbar .ql-formats button.ql-list[value='bullet'].ql-active svg path {
  stroke: #b9bac0;
}

.ql-snow .ql-picker {
  color: #636578;
}

.ql-toolbar .ql-formats button {
  position: relative;
}

.ql-toolbar .ql-formats button::after {
  content: attr(data-tooltip);
  position: absolute;
  background: varFigma(neutral-0-darkest);
  color: varFigma(neutral-95-lightest);
  font-family: 'Rubik';
  font-weight: 500;
  padding: 0.5em;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  top: 32px;
  left: 100%;
  transform: translateX(-50%);
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
}

.ql-toolbar .ql-formats button:hover::after {
  opacity: 1;
}

@media screen and (max-width: 768px) {
  .ql-header.ql-picker {
    display: none;
  }
}

.bg-dark {
  .ql-toolbar .ql-formats button.ql-list[value='bullet'] svg path {
    stroke: #b9bbc6;
    transition: stroke 0.2s ease;
  }
  .ql-picker-label {
    svg {
      fill: #b9bbc6 !important;
      transition: fill 0.2s ease !important;
    }
  }
  .ql-toolbar.ql-snow {
    background-color: #171924 !important;
    border-bottom: 1px solid #2c2c2c;
  }
  .ql-toolbar .ql-formats button {
    svg {
      fill: #b9bbc6 !important;
      transition: fill 0.2s ease !important;
    }

    &:hover svg {
      fill: #b9bac0 !important; // Hover
    }

    &.ql-active svg {
      fill: #b9bac0 !important; // Ativo
    }

    &.ql-disabled svg {
      fill: varFigma(neutral-70) !important;
    }
  }
}
</style>
